import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useClickOutside } from '@pascal/pascal-core';
import { autoBetCounts } from '../../../../enums/gameConstants';
import { betDataStore, doBetStore, gameStore } from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';

export const AutoBet = observer(({ t }) => {
  const { betsSectionsData, setIsAutoBet, selectAutoBetCount } = betDataStore;
  const { doBetSectionsData, doBetSender } = doBetStore;
  const { activeGameType } = gameStore;
  const { isBetAccepted } = doBetSectionsData[activeGameType];
  const { selectedAutoBetCount, isAutoBet, readyForAutoBet } = betsSectionsData[activeGameType];
  const [isOpenAutoBetCount, setIsOpenAutoBetCount] = useState(false);
  const [autoBetCountRef, hasOutsideClicked] = useClickOutside();
  const { AutoBet } = globalTranslationKeys;

  const handleAutoBat = () => {
    setIsAutoBet(!isAutoBet, activeGameType);
    if (!isAutoBet) {
      setIsOpenAutoBetCount(!isOpenAutoBetCount);
    }
  };

  const choseAutoBetCount = (count) => {
    selectAutoBetCount(count, activeGameType);
    if (readyForAutoBet && !isBetAccepted) {
      doBetSender(activeGameType);
    }
  };

  useEffect(() => {
    if (isAutoBet && !selectedAutoBetCount && hasOutsideClicked) {
      setIsOpenAutoBetCount(false);
      setIsAutoBet(!isAutoBet, activeGameType);
    } else if (isAutoBet && selectedAutoBetCount && !hasOutsideClicked) {
      setIsOpenAutoBetCount(false);
    }
  }, [isAutoBet, selectedAutoBetCount, hasOutsideClicked]);

  return (
    <div ref={autoBetCountRef} className={`bet-cashout-box  type${isAutoBet ? 1 : 2}`}>
      <div className={`bet-cashout-text-wrp `}>
        <p className='bet-cashout-text'>{t(AutoBet)}</p>
        <div
          className={`auto-bet-sq-box ${selectedAutoBetCount && isAutoBet ? '' : 'hide-element'}`}
        >
          <span>{selectedAutoBetCount}</span>
        </div>
      </div>

      <div
        className={`switch-box ${isAutoBet && isOpenAutoBetCount ? 'hide-element' : ''}`}
        onClick={handleAutoBat}
      >
        <div className={`game-switch ${isAutoBet ? 'active' : ''}`}>
          <div />
        </div>
      </div>
      <div className={`autobet-number-wrp ${isOpenAutoBetCount ? '' : 'hide-element'}`}>
        {autoBetCounts.map((count) => {
          return (
            <span key={count} onClick={() => choseAutoBetCount(count)} className='autobet-num '>
              {count}
            </span>
          );
        })}
      </div>
    </div>
  );
});
